import { TICKET_GET, FEEDBACK_LIST, FEEDBACK_ENGINEERS_ADMIN, ENGINEER_ADMIN_TICKETS, TICKET_COUNTS_ENG, EXISTING_TICKET, TICKET_BY_COMPANY, SUPERVISOR_TICKET_LIST, TICKET_COUNTS, ENGINEER_TICKET_LIST, REQUESTER_TICKET_LIST, TICKET_LIST, SUB_CAT_LIST, ENGINEERS_LIST, PRIORITY_LIST, STATUS_LIST, TYPE_LIST, GROUPS_LIST, COMPANY_LIST, TICKET_DISCUSSION_LIST_BY_TICKET, FILTERED_TICKETS, TIMER_STATUS, TICKET_UPDATE_BY_ENG, TICKET_UPDATE_BY_SUP, ADD_TICKET, REQUESTER_LIST, PAGINATED_TICKETS_LIST, TICKET_SEARCH, SET_FEEDBACK_MESSAGE, FETCH_TICKET_COUNT, UPDATE_DASHBOARD_COUNTS, FILTER_TICKETS_BY_STATUS, LOADING_FALSE, LOADING_TRUE, CLEAR_SEARCH_RESULTS, DASHBOARD_DETAILS } from './types'
import { Api } from '../../components/Api'
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

let timer: any;
export const launchTimer = (history: any) => {
    return function (dispatch: any) {
        console.log("launch timer");
        dispatch({
            type: TIMER_STATUS,
            payload: true
        })
        timer = setInterval(() => {

            //history.go(0)
            // const roleId = sessionStorage.getItem("role");
            // if (roleId === "5") {
            //     dispatch(assigneeTickets());
            // } else if (roleId === "3") {
            //     dispatch(requesterTickets());
            // } else if (roleId === "4") {
            //     dispatch(supervisorTickets());
            // }
            // else {
            //     dispatch(getTicketCount());
            // }
            // dispatch(getTicketCount());

        }, 30000);
    }
}

export const stopTimer = () => {
    console.log("stop Timer");
    return function (dispatch: any) {
        dispatch({
            type: TIMER_STATUS,
            payload: false
        });
        clearInterval(timer)
    }
}

export const ticketList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/getAll', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                // console.log("sessadsd",response);
                if (response.data.success) {
                    sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                    let recieved = 0;
                    let assigned = 0;
                    let resolved = 0;
                    let paused = 0;
                    let closed = 0;
                    response.data.successResponse.map((obj: any) => {
                        if (obj.ticket_status_code?.ticket_status_code === 1) {
                            return recieved += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 2) {
                            return assigned += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 3) {
                            return resolved += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 4) {
                            return paused += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 8) {
                            return closed += 1;
                        }
                    })
                    dispatch({
                        type: FILTERED_TICKETS,
                        payload: [],
                        emptyFilterOrder: false
                    })
                    dispatch({
                        type: TICKET_LIST,
                        payload: response.data.successResponse,
                        ticketsReceived: recieved,
                        ticketsAssigned: assigned,
                        ticketsResolved: resolved,
                        ticketsPaused: paused,
                        ticketsClosed: closed,
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const ticketListTimer = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/getAllTicketCount/web', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    let recieved = 0;
                    let assigned = 0;
                    let resolved = 0;
                    let paused = 0;
                    let closed = 0;
                    response.data.successResponse.map((obj: any) => {
                        if (obj.ticket_status_code?.ticket_status_code === 1) {
                            return recieved += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 2) {
                            return assigned += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 3) {
                            return resolved += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 4) {
                            return paused += 1;
                        } else if (obj.ticket_status_code?.ticket_status_code === 8) {
                            return closed += 1;
                        }
                    })
                    dispatch({
                        type: FILTERED_TICKETS,
                        payload: [],
                        emptyFilterOrder: false
                    })
                    dispatch({
                        type: TICKET_LIST,
                        payload: response.data.successResponse,
                        ticketsReceived: recieved,
                        ticketsAssigned: assigned,
                        ticketsResolved: resolved,
                        ticketsPaused: paused,
                        ticketsClosed: closed,
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

// Action Creator
export const getTicketCount = () => async (dispatch: any) => {
    let token: any = sessionStorage.getItem('token');
    Api.get('/tickets/getAllTicketCount/web', {
        headers: { 'Authorization': 'Bearer ' + token }
    })
        .then((response) => {
            if (response.data.success) {
                dispatch({
                    type: FETCH_TICKET_COUNT,
                    payload: response.data.count,
                });
            }
        }).catch(err => {
            if (err.response) {
                console.log(err.response.data.message)
            } else {
                alert(err.message)
            }
        });
};

// Action Creator
export const getTicketDashCount = () => async (dispatch: any) => {
    let token: any = sessionStorage.getItem('token');
    const roleId = sessionStorage.getItem("role");
    var user: any = jwt_decode(token);
    let data = {
        userId: user.userId,
        company: user.company,
        roleId: roleId
    }
    Api.post('/tickets/getTicketDashboardCount', data, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then((response) => {
        if (response.data.success) {
            console.log("Dashboard Counts:", response.data.data);

            const { received, assigned, resolved, paused, closed, total } = response.data.data;

            dispatch({
                type: UPDATE_DASHBOARD_COUNTS,
                payload: {
                    ticketsReceived: received,
                    ticketsAssigned: assigned,
                    ticketsResolved: resolved,
                    ticketsPaused: paused,
                    ticketsClosed: closed,
                    ticketsTotal: total
                }
            });
        }
    }).catch(err => {
        if (err.response) {
            console.log(err.response.data.message)
        } else {
            alert(err.message)
        }
    });
}

export const assigneeTickets = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        let data = {
            userId: user.userId,
            company: user.company
        }
        console.log("assTick in action", data);
        Api.post('/tickets/assignee_tickets', data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("ticket data in action:", response.data.successResponse)
                if (response.data.success) {
                    sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                    let recieved = 0;
                    let assigned = 0;
                    let resolved = 0;
                    let paused = 0;
                    let closed = 0;
                    response.data.successResponse.map((obj: any) => {
                        if (obj.ticket_status_code === 1) {
                            return recieved += 1;
                        } else if (obj.ticket_status_code === 2) {
                            return assigned += 1;
                        } else if (obj.ticket_status_code === 3) {
                            return resolved += 1;
                        } else if (obj.ticket_status_code === 4) {
                            return paused += 1;
                        } else if (obj.ticket_status_code === 8) {
                            return closed += 1;
                        }
                    })
                    console.log("ticket data in action:", response.data.successResponse)

                    dispatch({
                        type: TICKET_LIST,
                        payload: response.data.successResponse,
                        ticketsReceived: recieved,
                        ticketsAssigned: assigned,
                        ticketsResolved: resolved,
                        ticketsPaused: paused,
                        ticketsClosed: closed,
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const ticketListEng = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/tickets_assignee_performace/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                //console.log("ticket data in action:", response.data.successResponse)
                if (response.data.success) {
                    dispatch({
                        type: ENGINEER_ADMIN_TICKETS,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const supervisorTickets = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        Api.get(`/tickets/tickets_for_supervisor/${user.company}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                    console.log("ticket data in action:", response.data.successResponse)
                    let recieved = 0;
                    let assigned = 0;
                    let resolved = 0;
                    let paused = 0;
                    let closed = 0;
                    response.data.successResponse.map((obj: any) => {
                        if (obj.ticket_status_code === 1) {
                            return recieved += 1;
                        } else if (obj.ticket_status_code === 2) {
                            return assigned += 1;
                        } else if (obj.ticket_status_code === 3) {
                            return resolved += 1;
                        } else if (obj.ticket_status_code === 4) {
                            return paused += 1;
                        } else if (obj.ticket_status_code === 8) {
                            return closed += 1;
                        }
                    })
                    console.log("ticket data in action:", response.data.successResponse)

                    dispatch({
                        type: TICKET_LIST,
                        payload: response.data.successResponse,
                        ticketsReceived: recieved,
                        ticketsAssigned: assigned,
                        ticketsResolved: resolved,
                        ticketsPaused: paused,
                        ticketsClosed: closed,
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const requesterTickets = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        let data = {
            userId: user.userId,
            company: user.company
        }
        Api.post('/tickets/requester_tickets', data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                    let recieved = 0;
                    let assigned = 0;
                    let resolved = 0;
                    let paused = 0;
                    let closed = 0;
                    response.data.successResponse.map((obj: any) => {
                        if (obj.ticket_status_code === 1) {
                            return recieved += 1;
                        } else if (obj.ticket_status_code === 2) {
                            return assigned += 1;
                        } else if (obj.ticket_status_code === 3) {
                            return resolved += 1;
                        } else if (obj.ticket_status_code === 4) {
                            return paused += 1;
                        } else if (obj.ticket_status_code === 8) {
                            return closed += 1;
                        }
                    })
                    console.log("ticket data in action:", response.data.successResponse)

                    dispatch({
                        type: TICKET_LIST,
                        payload: response.data.successResponse,
                        ticketsReceived: recieved,
                        ticketsAssigned: assigned,
                        ticketsResolved: resolved,
                        ticketsPaused: paused,
                        ticketsClosed: closed,
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const addTicket = (formData: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post('/tickets/add_ticket', formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                "Content-Type": "multipart/form-data"
            }
        }).then((response) => {
            dispatch({
                type: ADD_TICKET,
                isLoad: true
            })
            if (response.data.success) {
                window.location.href = "/tickets";
            }
        }).catch(err => {
            if (err.response) {
                toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                console.log("sdvsdsdv", err.response.data.message)

            } else {
                alert(err.message)
            }
        });
    }
}

export const priorityList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/priority/gellAllActivePriority', {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then((response) => {
            let data = response.data;
            if (data.success) {
                dispatch({
                    type: PRIORITY_LIST,
                    payload: data.data
                })
            }
        }).catch(err => {
            if (err.response) {
                console.log(err.response.data.message)
            } else {
                alert(err.message)
            }
        });
    }
}

export const statusList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/get_status', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    let status = response.data.successResponse;
                    let adminStatus = [status[1], status[2], status[3]];
                    let supervisorStatus = [status[1]];
                    let engineerStatus = [status[2], status[1], status[3]];
                    let pausedStatus = [status[3]];
                    let resumeStatus = [status[1]]
                    // console.log("adminStatus",adminStatus);
                    //     let supervisorStatus = [status[1]];
                    //    console.log("status--------------",status);
                    //    let engineerStatus = [status[2]];          
                    dispatch({
                        type: STATUS_LIST,
                        payload: adminStatus,
                        supervisorStatus: supervisorStatus,
                        engineerStatus: engineerStatus,
                        pausedStatus: pausedStatus,
                        resumeStatus: resumeStatus
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const requestersList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        
        // Guard clause: Check if token exists
        if (!token) {
            dispatch({
                type: REQUESTER_LIST,
                payload: []
            });
            return;
        }

        try { 
            Api.get(`/user/getRequesters`, {
                headers: { 'Authorization': 'Bearer ' + token }
            })
                .then((response) => {
                    // Guard clause: Check if response and data exist
                    if (!response || !response.data) {
                        dispatch({
                            type: REQUESTER_LIST,
                            payload: []
                        });
                        return;
                    }

                    if (response.data.success) {
                        dispatch({
                            type: REQUESTER_LIST,
                            payload: response.data.data || []
                        });
                    }
                }).catch(err => {
                    dispatch({
                        type: REQUESTER_LIST,
                        payload: []
                    });
                    
                    if (err.response?.data?.message) {
                        console.log(err.response.data.message);
                    } else if (err.message) {
                        console.log(err.message);
                    }
                });
        } catch (error) {
            // Handle jwt_decode error
            console.log('Error decoding token:', error);
            dispatch({
                type: REQUESTER_LIST,
                payload: []
            });
        }
    }
}

export const groupList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        let user: any = jwt_decode(token);
        let data = {
            role: user.role,
            company: user.company
        }
        Api.post(`/tickets/groups_company`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: GROUPS_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                dispatch({
                    type: GROUPS_LIST,
                    payload: []
                })
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const typeList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/get_category', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    console.log("CAT: ", response.data.successResponse);
                    dispatch({
                        type: TYPE_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const feedbackList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/all-feedback', {
            headers: { 'Authorization': 'Bearer ' + token, 'Cache-Control': 'no-cache' }
        })
            .then((response) => {
                if (response.data.success) {
                    console.log("feedback: ", response.data.successResponse);
                    dispatch({
                        type: FEEDBACK_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const feedbackListEng = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/all-feedback-engineers/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    console.log("feedback: ", response.data.successResponse);
                    dispatch({
                        type: FEEDBACK_ENGINEERS_ADMIN,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const subCategoryList = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/sub-categories/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: SUB_CAT_LIST,
                        payload: response.data.successResponse
                    })

                }
            }).catch(err => {
                dispatch({
                    type: SUB_CAT_LIST,
                    payload: []
                })
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const engineersList = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        let user: any = jwt_decode(token);
        let data = {
            role: user.role,
            id: id
        }
        Api.post(`/tickets/get_engineers`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: ENGINEERS_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                dispatch({
                    type: ENGINEERS_LIST,
                    payload: []
                })
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const engineersListByRole = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        let data = {
            role: 5,
            id: id
        }
        Api.post(`/tickets/get_engineers`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: ENGINEERS_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                dispatch({
                    type: ENGINEERS_LIST,
                    payload: []
                })
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const getTicket = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/get/ticket/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then((response) => {
            // Handle both response.data.data and response.data.successResponse formats
            const ticketData = response.data.data || response.data.successResponse || {};
            const groupId = ticketData.group_id || ticketData.group || ticketData.tickets_group;
            const categoryId = ticketData.cat_id || ticketData.tickets_cat_id;
            
            if (groupId) {
                dispatch(engineersList(groupId));
            }
            if (categoryId) {
                dispatch(subCategoryList(categoryId));
            }
            dispatch({
                type: TICKET_GET,
                payload: ticketData
            })

        }).catch(err => {
            if (err.response) {
                console.log(err.response.data.message)
            } else {
                alert(err.message)
            }
        });
    }
}

export const updateTicketBySupervisor = (id: any, formData: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/tickets/update/assignedTicket/${id}`, formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                "Content-Type": "multipart/form-data"
            }
        })
            .then((response) => {
                if (response.data.success && response.data.successResponse) {
                    const ticketData = response.data.successResponse;
                    const groupId = ticketData.group_id || ticketData.group || ticketData.tickets_group;
                    const categoryId = ticketData.cat_id || ticketData.tickets_cat_id;
                    
                    if (groupId) {
                        dispatch(engineersList(groupId));
                    }
                    if (categoryId) {
                        dispatch(subCategoryList(categoryId));
                    }
                    
                    dispatch({
                        type: TICKET_UPDATE_BY_SUP,
                        isLoad: true,
                        payload: ticketData
                    })
                    dispatch({
                        type: TICKET_GET,
                        payload: ticketData
                    })
                    toast.success("Ticket updated successfully", { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    console.log("response", response);
                    window.location.href = "/tickets";
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                    toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                } else {
                    alert(err.message)
                }
            });
    }
}

export const reassignTicketByRequester = (data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put('/tickets/reassign_by_requester', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then((response) => {
                console.log("response", response);
                window.location.href = "/tickets";
                //toast.error(response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                    toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                } else {
                    alert(err.message)
                }
            });
    }
}

export const updateTicketByEngineer = (id: any, formData: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/tickets/update_by_engineer/${id}`, formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                "Content-Type": "multipart/form-data"
            }
        })
            .then((response) => {
                if (response.data.success && response.data.successResponse) {
                    const ticketData = response.data.successResponse;
                    const groupId = ticketData.group_id || ticketData.group || ticketData.tickets_group;
                    const categoryId = ticketData.cat_id || ticketData.tickets_cat_id;
                    
                    if (groupId) {
                        dispatch(engineersList(groupId));
                    }
                    if (categoryId) {
                        dispatch(subCategoryList(categoryId));
                    }
                    
                    dispatch({
                        type: TICKET_UPDATE_BY_ENG,
                        isLoad: true,
                        payload: ticketData
                    })
                    dispatch({
                        type: TICKET_GET,
                        payload: ticketData
                    })
                    toast.success("Ticket updated successfully", { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    console.log("response", response);
                    window.location.href = "/tickets";
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                    toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                } else {
                    alert(err.message)
                }
            });
    }
}

export const sendReply = (formData: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/tickets/add_ticket_discussion/`, formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                "Content-Type": "multipart/form-data"
            }
        })
            .then((response) => {
                console.log("response REPLY", response);
                dispatch(getTicket(formData.get("ticket_id")));
                dispatch(getAllTicketDiscussionByTicket(formData.get("ticket_id")));

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                    toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                    toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                } else {
                    alert(err.message)
                }
            });
    }
}

export const deleteTicket = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.delete(`/tickets/delete/${id}`)
            // {
            //     headers: { 'Authorization': 'Bearer ' + token }
            // })
            .then((response) => {
                console.log("response", response);
                window.location.href = "/tickets";
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const sendFeedback = (id: any, data: any) => async (dispatch: any) => {
    try {
        let token: any = sessionStorage.getItem('token');
        const response = await Api.post(`/tickets/send-feedback/${id}`, data, {
            headers: { 'Authorization': 'Bearer ' + token }
        });

        if (response.data.success) {
            dispatch({
                type: SET_FEEDBACK_MESSAGE,
                payload: response.data.message
            });
        } else {
            dispatch({
                type: SET_FEEDBACK_MESSAGE,
                payload: response.data.message
            });
        }
    } catch (e) {
        console.log(e);
    }
};

export const ticketCounts = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/ticket_counts', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: TICKET_COUNTS,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const fetchDashboardDetails = () => {
    return async function (dispatch: any) {
        const token: string | null = sessionStorage.getItem('token');
        if (!token) {
            return;
        }
        try {
            const response = await Api.get('/tickets/getdashboardetails', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.data.success) {
                dispatch({
                    type: DASHBOARD_DETAILS,
                    payload: response.data.data
                });
            }
        } catch (err: any) {
            if (err.response) {
                console.log(err.response.data.message);
            } else {
                alert(err.message);
            }
        }
    }
}

export const ticketCountsEng = (eng_id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');

        //var user: any = jwt_decode(token);
        Api.get(`/tickets/ticket_counts_eng/${eng_id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    //console.log("COUNT ENG: ", response.data.successResponse[0]);
                    dispatch({
                        type: TICKET_COUNTS_ENG,
                        payload: response.data.successResponse[0]
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const ticketsByCompany = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/tickets_by_company/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: TICKET_BY_COMPANY,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const companyList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/tickets/companies', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: COMPANY_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const getAllTicketDiscussionByTicket = (id: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/tickets/getTicketDiscussionByTicket/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("TICKET_DISCUSSION_LIST_BY_TICKET", response.data);

                let payload = [];
                if (response.data?.success && response.data?.data) {
                    payload = response.data.data || [];
                }

                dispatch({
                    type: TICKET_DISCUSSION_LIST_BY_TICKET,
                    payload
                });
            })
            .catch(err => {
                if (err.response) {
                    console.log("ERROR: ", err.response.data.message);
                } else {
                    alert(err.message);
                }
                dispatch({
                    type: TICKET_DISCUSSION_LIST_BY_TICKET,
                    payload: []
                });
            });
    };
};

export const assigneeTicketsTimer = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        let data = {
            userId: user.userId,
            company: user.company
        }
        console.log("assTick in action", data);
        Api.post('/tickets/assignee_tickets', data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("ticket data in action:", response.data.successResponse)
                dispatch({
                    type: ENGINEER_TICKET_LIST,
                    payload: response.data.successResponse
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const supervisorTicketsTimer = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        Api.get(`/tickets/tickets_for_supervisor/${user.company}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("ticket data in action:", response.data.successResponse)
                dispatch({
                    type: SUPERVISOR_TICKET_LIST,
                    payload: response.data.successResponse
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const requesterTicketsTimer = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        var user: any = jwt_decode(token);
        let data = {
            userId: user.userId,
            company: user.company
        }
        Api.post('/tickets/requester_tickets', data, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                console.log("ticket data in action:", response.data.successResponse)
                dispatch({
                    type: REQUESTER_TICKET_LIST,
                    payload: response.data.successResponse
                })

            }).catch(err => {
                if (err.response) {
                    console.log(err.response.data.message)
                } else {
                    alert(err.message)
                }
            });
    }
}

export const filterOrdersList = (filteredArr: any) => {
    return function (dispatch: any) {
        dispatch({
            type: FILTERED_TICKETS,
            payload: filteredArr,
            emptyFilterOrder: filteredArr.length > 0 ? false : true
        })
    }
}

export const paginatedTicketsList = (page: any) => {
    return async function (dispatch: any) {
        let pageSize = 20;
        let offset = page * pageSize;

        // ✅ Get token and userId from sessionStorage
        let token: any = sessionStorage.getItem('token');
        let userId: any = sessionStorage.getItem('userId'); // 👈 Get userId

        if (!userId) {
            console.error("User ID not found in sessionStorage");
            return;
        }

        dispatch({ type: PAGINATED_TICKETS_LIST + '_REQUEST' });

        try {
            const response = await Api.get(`/tickets/paginatedTicketsList/web`, {
                params: {
                    offset,
                    limit: pageSize,
                    userId  // ✅ Send userId as query parameter
                },
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.data.successResponse) {
                const ticketsData = response.data.successResponse;
                const totalTickets = response.data.total;

                // Update ticket count in sessionStorage
                sessionStorage.setItem('ticketLength', ticketsData.length);

                // Count status categories
                let recieved = 0, assigned = 0, resolved = 0, paused = 0, closed = 0;
                ticketsData.forEach((obj: any) => {
                    switch (obj.ticket_status_code) {
                        case 1: recieved++; break;
                        case 2: assigned++; break;
                        case 3: resolved++; break;
                        case 4: paused++; break;
                        case 8: closed++; break;
                    }
                });

                // Dispatch success with all required data
                dispatch({
                    type: FILTERED_TICKETS,
                    payload: ticketsData,
                    emptyFilterOrder: false
                });

                dispatch({
                    type: PAGINATED_TICKETS_LIST + '_SUCCESS',
                    payload: {
                        ticketsData,
                        totalTickets,
                        currentPage: page,
                    },
                    ticketsReceived: recieved,
                    ticketsAssigned: assigned,
                    ticketsResolved: resolved,
                    ticketsPaused: paused,
                    ticketsClosed: closed,
                });
            }
        } catch (err: any) {
            console.error("Error fetching paginated tickets:", err);
            if (err.response) {
                console.log(err.response.data.message);
            } else {
                alert(err.message);
            }
            dispatch({
                type: PAGINATED_TICKETS_LIST + '_FAILURE',
                payload: err.message
            });
        }
    };
};


export const ticketSearch = (id: any) => {
    return async function (dispatch: any) {
        let searchId = Number(id);
        if (typeof searchId !== "number") {
            // Display an error message for incorrect ID format
            alert("Please enter a valid ID number.");
            return;
        }
        let token: any = sessionStorage.getItem('token');
        let userId: any = sessionStorage.getItem('userId');
        dispatch({ type: TICKET_SEARCH + '_REQUEST' }); // Dispatch the request action
        await Api.get(`/tickets/searchTicket/${searchId}`, {
            params: {
                userId
            },
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then((response) => {
            if (response.data.successResponse) {
                sessionStorage.setItem('ticketLength', response.data.successResponse.length);
                dispatch({
                    type: FILTERED_TICKETS,
                    payload: [],
                    // payload: response.data.successResponse,
                    emptyFilterOrder: false
                })
                dispatch({
                    type: TICKET_SEARCH + '_SUCCESS',
                    payload: response.data.successResponse,
                })
            }
        }).catch(err => {
            dispatch({
                type: TICKET_SEARCH + '_FAILURE',
                message: 'No Ticket Found',
            })
            if (err.response) {
                console.log(err.response.data.message)
                toast.error(err, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
                toast.error(err.response.data.message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true, autoClose: 3000 });
            } else {
                alert(err.message)
            }
        });

    }
}

export const filterTicketsByStatus = (status_code: number, page: number) => {
    return async (dispatch: any) => {
        dispatch({ type: LOADING_TRUE });

        let token: any = sessionStorage.getItem("token");
        const roleId = sessionStorage.getItem("role");
        const user: any = jwt_decode(token);

        try {
            const response = await Api.post(
                `/tickets/filter`,
                {
                    status_code,
                    page: page + 1,
                    limit: 20,
                    roleId,
                    userId: user.userId,
                    company: user.company,
                },
                {
                    headers: { Authorization: "Bearer " + token },
                }
            );

            if (response.data.success) {
                const { data, totalPages, currentPage, totalCount } = response.data;
                dispatch({
                    type: FILTER_TICKETS_BY_STATUS,
                    payload: data,
                    pageCount: totalPages,
                    currentPage: 0,
                });
            }
        } catch (err: any) {
            console.error("Error fetching filtered tickets:", err);
            dispatch({ type: LOADING_FALSE });
        }
    };
};

// Action Creator
export const clearSearchResults = () => ({
    type: CLEAR_SEARCH_RESULTS
});



